module.exports = __webpack_public_path__ + "static/media/add-vertical-slider-icon.76c1412c.png";